export default {
  unknown: 'Desconocido',
  attachmentsToSend: 'Adjuntos para enviar con mensaje',

  labels: {
    patient: 'Paciente',
    viewTracker: 'Ver rastreador',
    tac: 'Términos y condiciones',
    faq: 'Preguntas frecuentes',
    writeReply: 'Escribir respuesta',
    translate: 'Traducir',
    chooseDate: 'Elegir una fecha',
    copyWithinGroup: 'Copiar dentro del grupo',
    selectDestination: 'Seleccionar destino',
    group: 'Grupo',
    subgroup: 'Subgrupo',
    beta: 'Esta sección del informe aún está en construcción',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    searchFaqs: 'Buscar preguntas frecuentes',
  },

  emoji: {
    people: 'Personas',
    nature: 'Naturaleza',
    places: 'Lugares',
    objects: 'Objetos',
    sybmols: 'Simbolos',
  },

  validations: {
    signature: {
      required: 'Signature is required',
    },
    widget: {
      required: 'Widget is required',
    },
    option: {
      required: 'Please select an option',
    },
    dosage: {
      required: 'Dosage is required field',
    },
    unit: {
      required: 'Please select a unit',
    },
    systolic: {
      required: 'Systolic value is required',
    },
    diastolic: {
      required: 'Diastolic value is required',
    },
    address: {
      required: 'Address is required field',
    },
    zipCode: {
      required: 'Zip code is required field',
    },
    city: {
      required: 'City is required field',
    },
    state: {
      required: 'State is required field',
    },
    patient: {
      required: 'Please select a patient',
    },
    subject: {
      required: 'Please input a subject',
    },
    firstName: {
      required: 'Please input a first name',
    },
    lastName: {
      required: 'Please input a last name',
    },
    fullName: {
      required: 'Please input a full name',
      invalid: 'Please input a valid full name',
    },
    email: {
      required: 'Please input an email',
      invalid: 'Please input a valid email',
    },
    mobileNumber: {
      required: 'Please enter a phone number',
      invalid: 'Please enter a valid phone number',
      invalidCountryCode: 'Please enter a valid phone number with country code',
      notTextable: 'Number not Textable',
    },
    callerId: {
      required: 'Caller Id Required',
    },
    smsSubject: {
      required: 'Please input a subject',
    },
    number: 'Value must be a number',
    numberBetween: 'A value should be more than {min} and less than {max}',
    checkboxes: {
      requiredAll: 'You have to check all checkboxes',
      atLeastOne: 'You have to check at least one',
    },
    date: {
      required: 'Please select a date',
    },
    time: {
      required: 'Please select a time',
    },
    text: {
      max: 'A value must not have more than {max} characters',
      min: 'A value must not have less than {min} characters',
    },
    file: {
      required: 'Please select a file',
      maxSize: 'File to big for upload (max size of {max}MB)',
    },
    required: 'Field is required',
    search: {
      atLeast: 'At least {count} characters',
    },
    name: {
      unique: 'The name should be unique',
    },
    frequency: {
      required: 'Debe especificar',
      pickOne: 'Elegir uno',
    },
  },

  buttons: {
    submit: 'Enviar',
    cancel: 'Cancelar',
    yes: 'Sí',
    no: 'No',
    clear: 'Claro',
    delete: 'Borrar',
    agree: 'Estar de acuerdo',
    disagree: 'Discrepar',
  },

  common: {
    loading: 'Loading...',
    noContent: 'No content',
    empty: 'Empty',
    httpError: 'Error desconocido. Por favor, inténtelo de nuevo más tarde.',
  },

  chat: {
    labels: {
      updatePatient: 'Update patient',
      noEmoji: 'There are no emojis with entered name',
      findConversation: 'Find conversation',
      findEmoji: 'Find emoji',
      reassign: 'Reassign',
      chat: 'Chat',
      startConversation: 'Start Conversation',
      waitingRoom: 'Waiting room',
      invitesSent: 'Invites sent',
      selectPatient: 'Select a patient',
      createPatient: 'Create new patient',
      onlyMyPatients: 'To search only your patients',
      myPatients: 'My patients',
      createPrivateConversation: 'To create a private conversation',
      privateConversation: 'Private conversation',
      textSubject: 'Text subject',
      emailSubject: 'Email subject',
      emailContent: 'Email body',
      mobileNumber: 'Mobile number',
      usCode: '+1',
      code: 'Code',
      status: 'Status',
      patientFullName: 'Patient First name and Last name',
      email: 'E-mail',
      mobile: 'Mobile',
      searchForPatient: 'Search for a patient or visitor',
      defaultSubject:
        '{firstName} {lastName} from {group} would like to start a secure conversation with you. Please click the link to accept.',
      markConversation: 'Mark this conversation as {label}?',
      assignConversation: 'Assign this conversation to {label}?',
      attachToMessage: 'Attach to message',
      saveAsTemplate: 'Save as Template',
      attachmentsToSend: 'Attachments to send with message',
      sendMessage: 'Send message',
      messagePreview: 'Message preview',
      invitationSent: 'Invitation sent to {message}',
      openConversationHeader: '{agentName} is conversing with the {personType}',
      waitingRoomHeader: '{botName} (Bot) is conversing with the {personType}',
      takeover: 'Takeover',
      blockTypingAlert:
        "This conversation is assigned to a bot. Takeover if you'd like to start the conversation.",
      blockTypingAlertAssign:
        "This conversation is assigned to {assignee}. You cannot reply unless it's assigned to you.",
      openedSubtab: 'Open conversations',
      widget: 'Widget',
      routine: 'Routine Follow-up',
      startVideoChatWarning: 'Would you like to start a Video Chat?',
      joinVideoChatWarning: 'Would you like to join a Video Chat?',
      startVoiceCallWarning: 'Would you like to start a Voice Call?',
      startCall: 'Start Call',
      startVoiceCall: 'Start a Voice Call',
      resendInvite: 'Resend Invite',
      resendInvitation: 'Resend invitation',
      editPatient: 'Edit patient',
      soloWarning: "Looks like you're the only one here!",
      interpreterDetails:
        '{name} will receive the following details at {email}:',
      facilityName: 'Facility Name',
      providerFirstName: 'Provider First Name',
      providerLastName: 'Provider Last Name',
      languageRequested: 'Language Requested',
      conversationLink: 'Conversation Link',
      patientEmailSubjectAlert:
        '{patient} will receive the above message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      selectInvintationSourse: 'Please select the invitation source',
      fillInRequiredFields: 'Please fill in all required fields',
      telephony: {
        callerIdHint:
          'The phone number that the patient will receive the call from',
        confirm:
          'Would you like to place a call from {callerId} to {phoneNumber}?',
        patientPhoneNumber: 'Patient Phone Number',
        providerCallerId: 'Provider Caller Id',
      },
    },

    messages: {
      success: {
        conversationCreate: 'A conversation has been created!',
        inviteResend: 'An invite has been successfully resent!',
        patientUpdate: 'Patient has been updated!',
      },

      warning: {
        deleteInvitation: 'Would you like to cancel the Invitation?',
      },

      error: {
        takeover: 'Failed to perform a takeover. Please try again later.',
        inviteResend: 'Failed to resend an invite. Please try again later.',
      },
    },

    audioTest: {
      userBrowser:
        'Versión del navegador en el sistema operativo del usuario Dispositivo de usuario',
      skip: 'Omitir',
      testAgain: 'Prueba de nuevo',
      viewTroubleShoot: 'Ver instrucciones de solución de problemas',
      instructions: 'Instrucciones de solución de problemas',
      start: 'PRUEBA TU EQUIPO',
      title: 'Prueba de Audio / Cámara',
      unsupported: 'No admitido',
      testCamera: 'Cámara de prueba',
      testAudio: 'Probar altavoz',
      testMicrophone: 'Prueba de micrófono',
      doYouSeeMic: '¿Ves una barra de progreso azul mientras hablas?',
      didYouHear: '¿Escuchaste el sonido?',
      playAgain: 'Juega de nuevo',
      loading: 'Detectando dispositivos...',
      canYouSee: '¿Puedes verte a ti mismo?',
      safariMessage:
        'Esta versión del navegador Safari tiene problemas con el audio. Apple ha lanzado una actualización para abordar los problemas de audio. Actualice su iOS a la última versión.',
      instruction:
        'Probaremos su cámara, micrófono y altavoz para asegurarnos de que tenga la mejor experiencia de visita virtual.',
    },

    virtualBg: {
      title: 'Escoge el fondo',
      preview: 'Avance',
      backgrounds: 'Antecedentes',

      names: {
        none: 'Ninguno',
        blur: 'Difuminar',
        add: 'Añadir imagen',
      },

      actions: {
        apply: 'Solicitar',
      },
    },
  },

  quickForms: {
    labels: {
      zip: 'Código postal',
      city: 'Ciudad',
      state: 'Estado',
      diastolic: 'Diastólico',
      systolic: 'Sistólico',
      time: 'Tiempo',
      unit: 'Unidad',
      timesPer: 'Veces por',
      formPreview: 'Vista previa del formulario',
      addAnother: 'Agrega otro',
    },
  },

  quickFormEditor: {
    configurationFields: {
      isSelectAllEnabled: 'Seleccionar todo',
    },
  },

  alerts: {
    chat: {
      resendInvitationWarn:
        '{patient} will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      noPhiEmail: 'No PHI here - this will be sent over Email',
      noPhiSms: 'No PHI here - this will be sent over SMS',
      smsInformation:
        'New patient will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
    },

    errors: {
      unexpected: 'Unexpected error happend. Please try again later',
      collectedInfo: 'No se puede cargar la información recopilada',
    },
  },
  videoChat: {
    errors: {
      permissions: {
        title: 'Nosotros no podemos conectarte',
        message: 'Looks like your audio or camera permissions have been denied',
        troubleshoot: 'Troubleshoot',
        clickBelow:
          'Please click "Troubleshoot" button below for a short clip on how to fix your permissions',
      },
      alreadyInUse: {
        title: 'Tu cámara o micrófono ya se está utilizando',
        message:
          'Otra aplicación puede estar usando su cámara o micrófono. ' +
          'Si está en algún tipo de llamada (phone call, Skype, Zoom, GoToMeeting, WebEx, etc), ' +
          'o grabando con su cámara o micrófono, detenga la llamada o la grabación, ' +
          'actualice la página, y vuelva a intentarlo.',
      },
      deviceMissing: {
        title: 'Necesitas un micrófono y una webcam',
        message:
          'No puede tener un chat de video sin tener un micrófono y una cámara web. ' +
          'Ambos son obligatorios. ' +
          'Conéctelos e instale los controladores de software que puedan faltar, ' +
          'luego actualice la página e intente nuevamente.',
      },
    },
    refreshPage: 'Refresh page',
    twilioError: {
      genericTitle: 'Twilio service interrupted',
      genericMessage:
        'Service should be up and running shortly, please check back later',
      '53000': {
        title: 'Internal Server Error',
      },
      '20500': {
        title: 'Signaling connection error',
      },
    },
  },
  timeUnits: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    length: 'A value should contain {count} characters',
    yesterday: 'Yesterday',
    toray: 'Today',
  },
  chooseOptions: 'Elija la opción',
}
